import angular from 'angular'

import extractRawElm from '../utils/extract-raw-elm'

import { toObject } from '../utils/bits'
import { get, noop } from 'lodash-es'
import { offEvent, onEventPassive } from '../utils/on-event'

angular
  .module('ggs.frame')
  .factory('FrameHack', FrameHackProvider)

function FrameHackProvider(frameHost) {
  return function FrameHack($iframeElm) {
    const iframeElm = extractRawElm($iframeElm)
    const iframeSrc = iframeElm.src
    if (frameHost.isVine(iframeSrc)) {
      return VineAutoplay(iframeElm)
    } else if (frameHost.isSoundcloud(iframeSrc)) {
      return SoundcloudLoop(iframeElm)
    } else {
      return Noop()
    }
  }

  function Noop() {
    return { destroy: noop }
  }

  function VineAutoplay(iframeElm) {
    // https://platform.vine.co/static/scripts/embed.js
    iframeElm.contentWindow.postMessage('pong', '*')
    iframeElm.contentWindow.postMessage('scrolledInToView', '*')
    iframeElm.contentWindow.postMessage('fullyInView', '*')
    return { destroy: noop }
  }

  function SoundcloudLoop(iframeElm) {
    // https://w.soundcloud.com/player/api.js
    iframeElm.contentWindow.postMessage(JSON.stringify({
      method: 'addEventListener',
      value: 'finish'
    }), '*')
    onEventPassive(window, 'message', onFinish)
    return { destroy }

    function destroy() {
      offEvent(window, 'message', onFinish)
    }

    function onFinish(event) {
      if (event.source !== iframeElm.contentWindow) return
      if (get(toObject(event.data), 'method') !== 'finish') return
      iframeElm.contentWindow.postMessage(JSON.stringify({
        method: 'play'
      }), '*')
    }
  }
}
